import { getWarningUnRead } from '@/api/system'
const state = {
  visible: false,
  unread: 0,
  message: null
}

const mutations = {
  CHANGE_MESSAGE: (state, data) => {
    state.message = data.message
    state.unread = data.unread
    state.visible = data.visible
  }
}

const actions = {
  async setState({ commit }) {
    const res = await getWarningUnRead()
    commit('CHANGE_MESSAGE', res.data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
